import { Box, Button, Grid, Typography, useTheme } from "@mui/material";
import { FC, useContext } from "react";
import MapFormContext from "../../contexts/data/MapFormContext";
import SpeciesFormsContext from "../../contexts/data/SpeciesFormsContext";

const ChooseLocationBanner: FC = () => {

    //
    // -- Hooks --
    const theme = useTheme();

    //
    // -- Contexts --
    const { maximiseDrawer, selectingLocationCoords, setSelectingLocationCoords, setMapFormData, mapFormData } = useContext(MapFormContext);
    const { selectedForm } = useContext(SpeciesFormsContext);

    const handleDoneClick = () => {
        if (selectingLocationCoords){
            setMapFormData({
                ...mapFormData,
                [selectedForm!.name]: {
                    ...mapFormData?.[selectedForm!.name],
                    "Latitude": selectingLocationCoords.lat,
                    "Longitude": selectingLocationCoords.lng,
                }
            });
        }
        maximiseDrawer();
    };

    const handleCancelClick = () => {
        if (selectedForm && mapFormData?.[selectedForm.name]?.["Latitude"] && mapFormData?.[selectedForm.name]?.["Longitude"]){
            setSelectingLocationCoords({
                lat: +mapFormData[selectedForm.name]["Latitude"],
                lng: +mapFormData[selectedForm.name]["Longitude"],
            });
        }
        else {
            setSelectingLocationCoords(undefined);
        }
        maximiseDrawer();
    };

    return (
        <Box 
            sx={{ 
                opacity: '0.85',
                position: 'absolute', 
                top: '0px', 
                width: '100%', 
                backgroundColor: theme.palette.primary.main 
            }}
        >
            <Grid 
                container 
                spacing={0} 
                alignItems="center"
                justifyItems="center"
            >
                <Grid 
                    item 
                    xs={3} sm={1}
                    sx={{ 
                        width: '100%', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'start', 
                        paddingY: '5px'
                    }}
                >
                    <Button 
                        sx={{ color: 'white', paddingLeft: '10px'}}
                        onClick={handleCancelClick}
                    >
                        Cancel
                    </Button>
                </Grid>
                <Grid 
                    item 
                    xs={6} sm={10}
                    sx={{ 
                        width: '100%', 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        paddingY: '5px'
                    }}
                >
                    <Typography variant="h4" color="white" textAlign="center" fontWeight="600">Choose location</Typography>
                    <Typography variant="subtitle1" color="white" textAlign="center">Tap on the map to place a marker</Typography>
                </Grid>
                <Grid 
                    item 
                    xs={3} sm={1}
                    sx={{ 
                        width: '100%', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'end', 
                        paddingY: '5px'
                    }}
                >
                    <Button
                        sx={{ color: 'white', paddingRight: '10px' }}
                        onClick={handleDoneClick}
                    >
                        Done
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
}

export default ChooseLocationBanner